/*
 * popupReducer
 * Description
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 04-Sep-2024
*/

import { produce } from 'immer'
import { actionTypes } from '../actions/popup'

const ACTION_HANDLERS = {
  [actionTypes.DO_SHOW_POPUP]: produce((draft, action) => {
    draft.popupKey = action.key
    draft.popupInfo = action.moreInfo
  }),
  [actionTypes.DO_HIDE_POPUP]: produce((draft) => {
    draft.popupKey = ''
    draft.popupInfo = {}
  })
  // @generator reducer:type:action

}

// The initial state of the popup
const initialState = {
  popupKey: '',
  popupInfo: {}
}

const popup = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default popup
